/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import UsersModal from "./UserForm";
import Constants from "../../../../common/Constants";
import MasterList from "../../../common/MasterList";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useTranslation } from "react-i18next";
import {
  fetchMasterList,
  addMasterRecord,
  deleteMasterRecord,
  searchMasterList,
} from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import { toastFunc } from "../../../../components/common/util";
import { ConfirmationModal } from "../../../common/ConfirmationModal";
import { ErrorModal } from "../../../common/errorModal";
import { ViewQRCode } from "../../../common/ViewQRCode";
import { AlertModal } from "../../../common/AlertModal";
import { formatDateTime } from "../../../../common/Validations";
import UserDepartment from "./UserDepartment";

const Users = () => {
  const [open, setOpen] = useState(false);
  const [searchValue, setSearchValue] = useState();
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");
  const [selectedItem, setSelectedItem] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [editUser, setEditUser] = useState();
  const [confirmModel, setConfirmModel] = useState(false);
  const [isAlert, setIsAlert] = useState(false);
  const [qrModal, setQRModal] = useState(false);
  const [qrValues, setQRValues] = useState([]);
  const [openDepartment, setOpenDepartment] = useState(false);
  const [user, setUser] = useState();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handleClose = () => {
    setOpen(false);
  };

  const [visiblePins, setVisiblePins] = useState({});

  const togglePinVisibility = (id) => {
    setVisiblePins((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  useEffect(() => {
    dispatch(fetchMasterList(Constants.MASTER.USERS)); // userSlice store
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSave = (data, edit) => {
    const param = { ...data };
    if (!edit) {
      param.method = Constants.MASTER.USERS.ADD;
    } else {
      param.method = Constants.MASTER.USERS.UPDATE;
    }
    param.edit = edit;
    dispatch(addMasterRecord(param)).then((res) => {
      if (res?.payload?.status === 200) {
        if (!edit) {
          toastFunc(
            Constants.MASTER.TOAST.success,
            t("msg_master_list.msg_user.success_message"),
            2000,
          );
        } else {
          toastFunc(
            Constants.MASTER.TOAST.success,
            t("msg_master_list.msg_user.update_success_message"),
            2000,
          );
        }
        dispatch(fetchMasterList(Constants.MASTER.USERS)); // userSlice store
        setOpen(false);
      } else if (res?.payload?.errorcode === 1007) {
        setError(t("msg_master_list.msg_user.duplicate_user"));
        setIsError(true);
      } else if (res?.payload?.errorcode === 1009) {
        setError(res?.payload?.message);
        setIsError(true);
      } else {
        setError(t("msg_master_list.msg_user.user_add_error"));
        setIsError(true);
      }
    });
  };

  const handleDepartmentSave = (data) => {
    const param = { ...data };
    param.method = Constants.MASTER.USERS.UPDATE;
    param.edit = true;
    dispatch(addMasterRecord(param)).then((res) => {
      console.log(">> item >>", res);
      if (res?.payload?.status === 200) {
        toastFunc(
          Constants.MASTER.TOAST.success,
          t("msg_master_list.msg_user.update_success_message"),
          2000,
        );
        setUser(data);
        dispatch(fetchMasterList(Constants.MASTER.USERS)); // userSlice store
        setOpen(false);
      } else {
        setError(t("msg_master_list.msg_user.user_add_error"));
        setIsError(true);
      }
    });
  };

  const handleDelete = () => {
    let param = {};
    param.userList = selectedItem;
    param.method = Constants.MASTER.USERS.DELETE;

    dispatch(deleteMasterRecord(param)).then((res) => {
      console.log(">> item >>", res);
      if (res?.payload?.status === 200) {
        toastFunc(
          Constants.MASTER.TOAST.success,
          t("msg_master_list.msg_user.delete_success_message"),
          2000,
        );
        dispatch(fetchMasterList(Constants.MASTER.USERS));
        setSelectedItem([]);
        setConfirmModel(false);
      } else {
        setIsError(true);
        toastFunc(
          Constants.MASTER.TOAST.error,
          t("msg_master_list.msg_user.invalid_input"),
          4000,
        );
      }
    });
  };

  const handleOpen = (data) => {
    if (data) {
      setEditUser(data);
    }
    setOpen(true);
  };
  const resetAlert = () => {
    setIsAlert(false);
  };
  const resetQRModal = () => {
    setQRModal(false);
  };

  const handleRowSelected = ({ selectedRows }) => {
    const selectUser = [];
    setSelectedRows(selectedRows);
    selectedRows.forEach((item) => {
      if (item.category === "ADMIN") {
        setError(t("msg_master_list.msg_user.user_admin_delete_error"));
        setIsError(true);
      } else {
        selectUser.push(item.userId);
      }
    });
    setSelectedItem([...selectUser]);
  };

  const handleQRCode = () => {
    if (selectedRows.length > 0) {
      setQRModal(true);
      setQRValues(selectedRows);
    } else {
      setIsAlert(true);
    }
  };
  const confirmBeforeDelete = (data, singleDelete = false) => {
    if (singleDelete) {
      setSelectedItem([data.userId]);
      setConfirmModel(true);
    } else {
      if (selectedItem.length === 0) {
        setIsAlert(true);
        return;
      } else {
        setConfirmModel(true);
      }
    }
  };

  const resetError = () => {
    setIsError(false);
    setError("");
  };

  let masterList = useSelector((state) => state?.masterList?.page); // User Details from Store

  let rowsData = masterList[Constants.MASTER.USERS.name]?.data;

  const handleSearch = () => {
    const param = {
      ...Constants.MASTER.USERS,
      value: searchValue,
    };
    if (searchValue) {
      dispatch(searchMasterList(param)).then((res) => {
        if (res?.payload?.status === 200) {
          rowsData = res?.payload?.data;
        }
      });
    }
  };

  const onSearchChange = (e) => {
    if (e.target.value) {
      setSearchValue(e.target.value);
    } else {
      dispatch(fetchMasterList(Constants.MASTER.USERS));
      setSearchValue(e.target.value);
    }
  };

  const handleDepartment = (row) => {
    setOpenDepartment(true);
    setUser(row);
  };

  const handlecloseDepartment = () => {
    setOpenDepartment(false);
  };

  const columnsData = [
    {
      name: t("msg_common.actions"),
      cell: (row) => (
        <>
          <span>
            <i
              className="bi bi-pencil-square iconTable"
              onClick={() => handleOpen(row)}
            ></i>
          </span>
          <span>
            {row.category !== "ADMIN" && (
              <i
                className="bi bi-trash3 iconTable"
                onClick={() => confirmBeforeDelete(row, true)}
              ></i>
            )}
          </span>
        </>
      ),
      width: "100px",
    },
    {
      name: t("msg_master_list.msg_user.pin"),
      selector: (row) => row.pin,
      sortable: true,
      width: "160px",
      cell: (row) => {
        const isVisible = visiblePins[row._id];

        return (
          <div className="pin-wrapper">
            <div className="pin-container">
              {String(row.pin || "")
                .padStart(4, "0")
                .split("")
                .map((digit, index) => (
                  <span key={index} className={isVisible ? "pin-digit" : "pin-digit-hidden"}  >
                    {isVisible ? digit : "*"}
                  </span>
                ))}
            </div>

            <button
              type="button"
              className="pin-toggle-btn"
              onClick={() => togglePinVisibility(row._id)}
            >
              <i
                className={`bi ${
                  isVisible ? "bi-eye-slash-fill" : "bi-eye-fill"
                }`}
              />
            </button>
          </div>
        );
      },
    },
    {
      name: t("msg_master_list.msg_user.id"),
      selector: (row) => row.userId,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.userId}
          </span>
          {/* <p className="m-0 p-0 pt-1 fw-datatable-row">{row.userId} </p> */}
        </>
      ),
    },
    {
      name: t("msg_master_list.msg_user.user_first_name"),
      selector: (row) => row.firstName,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.firstName} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_user.user_last_name"),
      selector: (row) => row.lastName,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.lastName} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_user.departments"),
      selector: (row) => row.category,
      sortable: true,
      cell: (row) =>
        (row.category === Constants.MASTER.USERS.TEAMLEAD ||
          row.category === Constants.MASTER.USERS.SUPERVISOR) && (
          <Button
            variant="outline-primary"
            onClick={(e) => {
              e.preventDefault();
              handleDepartment(row);
            }}
          >
            {t("msg_master_list.msg_user.departments")}
          </Button>
        ),
      center: true,
      width: "250px",
    },
    {
      name: t("msg_master_list.msg_user.email"),
      selector: (row) => row.email,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.email} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_user.contactNo"),
      selector: (row) => row.contactNumber,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.contactNumber} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_user.role"),
      selector: (row) => row.category,
      sortable: true,
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-second-status">
            {row.category}
          </span>
        </>
      ),
      center: true,
      width: "160px",
    },
    {
      name: t("msg_common.status"),
      selector: (row) => row.userStatus,
      sortable: true,
      cell: (row) => (
        <>
          {row.userStatus === Constants.MASTER.STATUS.Active ? (
            <span className="bg-table-status bg-table-success-status">
              {t("msg_common.active")}
            </span>
          ) : row.userStatus === Constants.MASTER.STATUS.Inactive ? (
            <span className="bg-table-status bg-table-danger-status">
              {t("msg_common.inactive")}
            </span>
          ) : (
            row.userStatus
          )}
        </>
      ),
      center: true,
      width: "150px",
    },
    {
      name: t("msg_master_list.msg_user.qc_access"),
      selector: (row) => row.qcAccessReq,
      sortable: true,
      cell: (row) => (
        <>
          {row.qcAccessReq === t("msg_common.Yes") ? (
            <span className="bg-table-status bg-table-success-status">
              {t("msg_common.Yes")}
            </span>
          ) : row.qcAccessReq === t("msg_common.No") ? (
            <span className="bg-table-status bg-table-danger-status">
              {t("msg_common.No")}
            </span>
          ) : (
            row.qcAccessReq
          )}
        </>
      ),
      center: true,
      width: "150px",
    },
    {
      name: t("msg_common.created_date"),
      selector: (row) => row.createdDate,
      sortable: true,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">
            {formatDateTime(row?.createdDate)}{" "}
          </p>
        </div>
      ),
      center: true,
      width: "150px",
    },
  ];

  return (
    <main className="dashboard main" id="main">
      <Row className="justify-center subContent">
        <Col xs={8} md={8} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">{t("msg_master_list.msg_user.name")}</h2>
            <p className="subText">{t("msg_master_list.msg_user.details")}</p>
          </div>
        </Col>
        <Col xs={4} md={4} className="rightSide">
          <Form>
            <Form.Group>
              <InputGroup>
                <Form.Control
                  type="search"
                  placeholder={t("msg_master_list.msg_user.search_placeholder")}
                  onChange={(e) => onSearchChange(e)}
                />
                <InputGroup.Text>
                  <i className="bi bi-search" onClick={handleSearch}></i>
                </InputGroup.Text>
              </InputGroup>
            </Form.Group>
          </Form>
        </Col>
        <hr />
      </Row>
      <MasterList
        columnsData={columnsData}
        rowsData={rowsData}
        paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
        pagination
        selectableRows
        handleClose
        handleOpen={handleOpen}
        handleDelete={confirmBeforeDelete}
        handleRowSelected={handleRowSelected}
        extraButton={true}
        handleBtnClick={handleQRCode}
      />
      {open && (
        <UsersModal
          data={editUser}
          show={open}
          onHide={handleClose}
          onSave={handleSave}
        ></UsersModal>
      )}
      {confirmModel && (
        <ConfirmationModal
          show={confirmModel}
          heading={t("msg_master_list.msg_user.delete_confirm_heading")}
          bodyMessage={t("msg_master_list.msg_user.delete_confirm_body")}
          onDelete={() => handleDelete()}
          onHide={() => setConfirmModel(false)}
          type={"delete"}
        ></ConfirmationModal>
      )}
      {isError && (
        <ErrorModal
          show={isError}
          heading={t("msg_master_list.msg_user.user_error_heading")}
          bodyMessage={error}
          onHide={() => {
            resetError();
          }}
        ></ErrorModal>
      )}
      {isAlert && (
        <AlertModal
          show={isAlert}
          heading={"Alert"}
          bodyMessage={"Please Select Record"}
          onHide={() => {
            resetAlert();
          }}
        ></AlertModal>
      )}
      {qrModal && (
        <ViewQRCode
          selectedItems={qrValues}
          show={true}
          onHide={() => {
            resetQRModal();
          }}
        ></ViewQRCode>
      )}
      {openDepartment && (
        <UserDepartment
          show={true}
          user={user}
          onHide={handlecloseDepartment}
          onAdd={handleDepartmentSave}
        ></UserDepartment>
      )}
    </main>
  );
};

export default Users;
